// Filename - pages/index.js
import React, { useEffect, useState } from 'react';
import { Button, TextField} from '@mui/material';
import { useAuth } from '../services/AuthContext.js';
import { toggleLessonList } from './course_content_script.js';
import { MessageSquare, MessageCircle, Unlock, Lock, GraduationCap, Send, User, Clock, Hash, ArrowRightCircle} from "lucide-react";
import Rodape from './rodape.js';
import RodapeInternal from './rodape_internal.js';
import CheckoutSingle from './checkout_single_step/checkout_single.js';
import OfferSection from './checkout_single_step/offer_section.js';
import StickySalesCta from './checkout_single_step/sticky_sales_cta.js';
import EditCreditCard from './checkout/edit_credit_card.js';
import { AllCoursesList2, AllCoursesListForLoggedUsersInHome, AllCoursesListForHome, CourseList, Lesson, Dashboard, Dashboard2, CourseListPublic, CourseListPrivate, CoursesCarouselPublic, ScreenshotsCarouselPublic } from './course_list';
import News from './news/news.js';
import { Leaderboard } from './leaderboard';
import { Network } from './network.js';
import { Forum, ForumTopics, TopicMessages } from './forum.js';
import { Chats, ChatView } from './chats.js';
import Account from './account/account.js';
import AccountEdit from './account/account_edit.js';
import AccountPublic from './account/account_public.js';
import Post from './post/post.js';
import Feed from './feed/feed.js';
import { useParams } from 'react-router-dom';
import userpool from '../userpool';
import { PageList, KnowCourseFromBlogButton, AnswerText} from './answer_post';
import { Header } from './header.js';
import { HeaderInternal } from './header_internal.js';
import { HeaderCheckout } from './header_checkout.js';
import LessonSidebar from '../components/LessonSidebar';
import '../components/LessonSidebar.css';
import { Signup, SignupSite, SignupSiteNew } from './account/signup.js';
import {Job} from './jobs.js';
import "./advantage.css";
import { BookOpen, Briefcase, Trophy, UserCircle, StickyNote, Puzzle } from "lucide-react";
import CourseFeature from './course_feature/course_feature.js';
import Bio from './bio/bio.js';
import Reviews from './reviews/reviews.js';
import CourseContent from './course_content/course_content.js';
import Sobre from './sobre.js';
import About from './about/about.js';
import Contact from './contact/contact.js';
import Conteudo from './conteudo.js';
import Circuitos from './circuitos.js';
import Avaliacoes from './avaliacoes.js';
import Requisitos from './requisitos.js';
import Teoria from './teoria.js';
import Pratica from './pratica.js';
import Duvidas from './duvidas/duvidas.js';
import DuvidasList from './duvidas_list/duvidas_list.js';
import Antigos from './antigos.js';
import Benefits from './benefits/benefits.js';
import Hero2 from './hero2/hero2.js';

let user=userpool.getCurrentUser();
const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

const Home = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const [accountType, setAccountType] = useState('unknown');
    const { user, loading, getIdToken } = useAuth();
    const [utmSource, setUtmSource] = useState(null);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const source = urlParams.get('utm_source');
        
        if (source) {
        setUtmSource(source);
        }
    }, []);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    const fetchAccountType = async () => {
        if (!user) {
        return;
        }
        try {
        const token = await getIdToken();     
        const res = await fetch(`${baseAPI_URL}/users/get-user-data`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const data = await res.json(); // assume it's a list of course IDs
        setAccountType(data.account_type);
        } catch (err) {
        console.error("Failed to fetch user data", err);
        }
    };
    useEffect(() => {
        fetchAccountType();
    }, [user]);

	return (
        <>
        <Header isMobile={isMobile}/>
        <Hero />
        <Signup />
        <CoursesCarouselPublic place={"home_page"} />
        <Reviews />
        <ScreenshotsCarouselPublic />
        <Bio />
        <Rodape />
        </>
	);
};

const Premium = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const { user, getIdToken } = useAuth();
    const [utmSource, setUtmSource] = useState(null);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const source = urlParams.get('utm_source');
        
        if (source) {
        setUtmSource(source);
        }
    }, []);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Hero2 />
        <Benefits />
        <Reviews />
        <OfferSection />
        <ScreenshotsCarouselPublic />
        <CoursesCarouselPublic place={"sales_page"} />
        <DuvidasList />
        <Bio />
        <Rodape />
        <StickySalesCta />
        </>
	);
};

const CheckoutSinglePage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 900px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderCheckout />
        <CheckoutSingle isMobile={isMobile} />
        </>
    );
};

const FreePage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const { user, getIdToken } = useAuth();
    const [utmSource, setUtmSource] = useState(null);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const source = urlParams.get('utm_source');
        
        if (source) {
        setUtmSource(source);
        }
    }, []);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Hero />
        <Signup />
        <CoursesCarouselPublic place={"free_page"} />
        <Reviews />
        <ScreenshotsCarouselPublic />
        <Bio />
        <Rodape />
        </>
	);
};

const Circuits = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <CircuitsSec1 />
        <Rodape />
        </>
	);
};

const SobrePage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Sobre />
        <Rodape />
        </>
	);
};

const AboutPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <About />
        <Rodape />
        </>
	);
};

const ContactPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Contact />
        <Rodape />
        </>
	);
};

const ConteudoPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Conteudo />
        <Rodape />
        </>
	);
};

const CircuitosPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Circuitos />
        <Rodape />
        </>
	);
};

const AvaliacoesPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Avaliacoes />
        <Rodape />
        </>
	);
};

const RequisitosPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Requisitos />
        <Rodape />
        </>
	);
};

const TeoriaPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Teoria />
        <Rodape />
        </>
	);
};

const PraticaPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Pratica />
        <Rodape />
        </>
	);
};

const DuvidasPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Duvidas />
        <Rodape />
        </>
	);
};

const AntigosPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <Antigos />
        <Rodape />
        </>
	);
};

const AnswerList = () => {
    //const [showOffer, setGlobalVariable] = useState(false);

    //const handleVariableChange = (newValue) => {
        // Update the globalVariable when needed
      //  setGlobalVariable(newValue/);
    //};

    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <section className="section">
		<PageList />
        <BioBlog />
        </section>
        <Rodape />
        </>
	);
};

const Answer = () => {
/*     const [showOffer, setGlobalVariable] = useState(false);

    const handleVariableChange = (newValue) => {
        // Update the globalVariable when needed
        setGlobalVariable(newValue);
    }; */

    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <Header isMobile={isMobile}/>
        <section className="section">
		<AnswerText />
        <AllCoursesListForHome/>
        <SignupSite />
        <BioBlog />
        </section>
        <Rodape />
        </>
	);
};

const AllCoursesPage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <AllCoursesList2/>
        <RodapeInternal />
        </>
    );
};

const SignupPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <Header isMobile={isMobile}/>
        <Signup/>
        <Rodape />
        </>
    );
};

const JobPage = () => {
    const { jobId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section-no-space">
        <Job jobId={jobId}/>
        </section>
        <RodapeInternal />
        </>
    );
};

const DashboardPage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <Dashboard2/>
        <RodapeInternal />
        </>
    );
};

const NewsPage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <News/>
        <RodapeInternal />
        </>
    );
};

const LeaderboardPage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section">
        <Leaderboard/>
        </section>
        <RodapeInternal />
        </>
    );
};

const NetworkPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section">
        <Network/>
        </section>
        <RodapeInternal />
        </>
    );
};

const CoursePage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <CourseListPrivate courseId={courseId}/>
        <RodapeInternal />
        </>
    );
};

const CoursePagePublic = () => {
    const { courseSlug } = useParams();
    const { getIdToken } = useAuth();
    const [isMobile, setIsMobile] = React.useState(false);
    const [accountType, setAccountType] = useState('unknown');
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    const fetchAccountType = async () => {
        if (!user) {
        return;
        }
        try {
        const token = await getIdToken();
        const res = await fetch(`${baseAPI_URL}/users/get-user-data`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const data = await res.json(); // assume it's a list of course IDs
        setAccountType(data.account_type);
        } catch (err) {
        console.error("Failed to fetch user data", err);
        }
    };
    useEffect(() => {
        fetchAccountType();
    }, [user]);
    let element;

    if (!user) {
        element = <OfferSection />;
    } else if (accountType == "free") {
        element = <OfferSection />;
    } else {
        element = null;
    }
    return (
        <>
        <Header isMobile={isMobile}/>
        <CourseListPublic courseSlug={courseSlug}/>
        {element}
        <ScreenshotsCarouselPublic/>
        <CoursesCarouselPublic place={"course_page_public"}/>
        <Rodape />
        </>
    );
};

const LessonPage = () => {
    const { courseId, sectionId, lessonId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    const [currentSectionId, setCurrentSectionId] = useState(sectionId);
    const [currentLessonId, setCurrentLessonId] = useState(lessonId);
    const [isCompleted, setIsCompleted] = useState(false);
    
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    
    React.useEffect(() => {
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    const handleLessonChange = (newSectionId, newLessonId) => {
        setCurrentSectionId(newSectionId);
        setCurrentLessonId(newLessonId);
    };

    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <LessonSidebar 
            courseId={courseId} 
            currentLessonId={currentLessonId}
            onLessonChange={handleLessonChange}
            isCompleted={isCompleted}
        />
        <Lesson 
            courseId={courseId} 
            sectionId={currentSectionId} 
            lessonId={currentLessonId}
            onLessonChange={handleLessonChange}
            isCompleted={isCompleted}
            setIsCompleted={setIsCompleted}
        />
        <RodapeInternal />
        </>
    );
};

const ForumPage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section">
        {!isMobile && (
            <div className="forum-header">
            <h1 className="forum-title">
            <MessageSquare className="forum-title-icon" size={40} />
                Fórum de Discussão
            </h1>
            <p className="forum-subtitle">Conecte, discuta e compartilhe com a nossa comunidade</p>
            </div>
        )}
        <div className="forum-layout">
            <ForumTopics/>
        </div>
        </section>
        <RodapeInternal />
        </>
    );
};

const TopicPage = () => {
    const { topicId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section">
        {!isMobile && (
            <div className="forum-header">
            <h1 className="forum-title">
            <MessageSquare className="forum-title-icon" size={40} />
                Tópico
            </h1>
            <p className="forum-subtitle">Entre na conversa deste tópico</p>
            </div>
        )}
        <div className="forum-layout">
            <TopicMessages topicId={topicId}/>
        </div>
        </section>
        <RodapeInternal />
        </>
    );
};

const ChatsPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section">
        <Chats/>
        </section>
        <RodapeInternal />
        </>
    );
};

const AccountPage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <Account/>
        <RodapeInternal />
        </>
    );
};

const AccountEditPage = () => {
    const { courseId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <AccountEdit/>
        <RodapeInternal />
        </>
    );
};

const AccountPublicPage = () => {
    const { slug } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <AccountPublic slug={slug}/>
        <RodapeInternal />
        </>
    );
};

const PostPage = () => {
    const { postId } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section">
        <Post postId={postId}/>
        </section>
        <RodapeInternal />
        </>
    );
};

const FeedPage = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <Feed/>
        <RodapeInternal />
        </>
    );
};

const ChatPage = () => {
    const { chatCode } = useParams();
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <section className="section">
        <ChatView chatCode={chatCode}/>
        </section>
        <RodapeInternal />
        </>
    );
};


export { AllCoursesPage,
         Home,
         Premium,
         CheckoutSinglePage,
         FreePage,
         SignupPage,
         CoursePage,
         CoursePagePublic,
         LessonPage,
         Answer,
         AnswerList,
         ForumPage,
         TopicPage,
         ChatsPage,
         AccountPage,
         AccountEditPage,
         AccountPublicPage,
         PostPage,
         FeedPage,
         ChatPage,
         DashboardPage,
         NewsPage,
         LeaderboardPage,
         NetworkPage,
         EditCreditCardPage,
         JobPage,
         Circuits,
         SobrePage,
         AboutPage,
         ContactPage,
         ConteudoPage,
         CircuitosPage,
         AvaliacoesPage,
         RequisitosPage,
         TeoriaPage,
         PraticaPage,
         DuvidasPage,
         AntigosPage };

function NewIntro() {
    // State to track the device type
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };

    // Check the device type when the component mounts
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    if (isMobile) {
        return(
            <div className="content-container-header">
                <div className='empty-div-Quero fazerheader'></div>
                <NewHeaderCTA isMobile={isMobile}/>
            </div>
        );
    } else {
        return(
            <div className="content-container-header">
                <NewHeaderCTA isMobile={isMobile}/>
                <div className='empty-div-header'></div>
            </div>
        );
    }

}

function NewIntroSite() {
    // State to track the device type
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };

    // Check the device type when the component mounts
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    if (isMobile) {
        return(
            <div className="content-container-header">
                <div className='empty-div-header'></div>
                <NewHeaderCTASite isMobile={isMobile}/>
            </div>
        );
    } else {
        return(
            <div className="content-container-header">
                <NewHeaderCTASite isMobile={isMobile}/>
                <div className='empty-div-header'></div>
            </div>
        );
    }

}

function Video() {
    return (
        <div className="video-container">
            {/* <SectionTracker sectionId="Video" /> */}
            <div style={{ position: 'auto' }}>
            <iframe 
            src="https://iframe.mediadelivery.net/embed/236258/d1284905-28a8-4af9-88b0-9b06f85da446?autoplay=false&loop=false&muted=false&preload=true&responsive=true" 
            width="480" 
            height="270" 
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" 
            allowFullScreen={true}
            title="Curso Domínio Elétrico"
            ></iframe>
            </div>
        </div>
    );
}

function CustomVideo({ videoId }) {
    const src = `https://iframe.mediadelivery.net/embed/236258/${videoId}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`;
    return (
        <div className="video-container">
            {/* <SectionTracker sectionId="Video" /> */}
            <div style={{ position: 'auto' }}>
            <iframe 
            src={src}
            width="480" 
            height="270" 
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" 
            allowFullScreen={true}
            title="Curso Domínio Elétrico"
            ></iframe>
            </div>
        </div>
    );
}

function FormButton({ buttonName }) {
    const handleClick = () => {
        // Push the data to the dataLayer when the button is clicked
        /* window.dataLayer.push({
            event: 'clickForOfertaDE', // Custom event name
            buttonName: 'clickForOfertaDE', // Custom event data, you can adjust this as needed
        });
        logEvent('ButtonClick', `${buttonName} clicked`);
        saveDesiteEventInDB("click_oferta", utmTags.v); */
        // Redirect the user after pushing the data to GTM if needed
        window.location.href = '#form'; // Redirect to the form anchor
    };

    return (
        <button className="btn-inscricao" onClick={handleClick}>
            Quero fazer o curso
        </button>
    );
}

function FormButtonSite({ buttonName }) {
    const handleClick = () => {
        // Push the data to the dataLayer when the button is clicked
        /* window.dataLayer.push({
            event: 'clickForOfertaDE', // Custom event name
            buttonName: 'clickForOfertaDE', // Custom event data, you can adjust this as needed
        });
        logEvent('ButtonClick', `${buttonName} clicked`);
        saveDesiteEventInDB("click_oferta", utmTags.v); */
        // Redirect the user after pushing the data to GTM if needed
        window.location.href = '#form'; // Redirect to the form anchor
    };

    return (
        <div className='formfield'>
            <Button variant='contained' className="std-button" onClick={handleClick}>
                Criar minha conta no site
            </Button>
        </div>
    );
}

function NewHeaderCTA({isMobile}) {
    if (isMobile) {
        return (
            <div id="headercta" className="new-header-container">
                {/* <SectionTracker sectionId="HeaderCTA" /> */}
                <h2 className='highlighted-heading'>Está difícil aprender a matéria de circuitos elétricos?</h2>
                <p>Eu, <b>Prof. Nicholas Yukio</b>, engenheiro eletrônico pelo ITA, criei este curso online para quem não consegue aprender só com o material do curso técnico ou faculdade.</p><p>Veja todas as informações sobre o conteúdo do curso nesta página.</p>
                <FormButton buttonName="HeaderCTA" />
            </div>
          );
    } else {
        return (
            <div id="headercta" className="new-header-container">
                {/* <SectionTracker sectionId="HeaderCTA" /> */}
                <h2 className='highlighted-heading'>Está difícil aprender a matéria de circuitos elétricos?</h2>
                <p>Eu, <b>Prof. Nicholas Yukio</b>, engenheiro eletrônico pelo ITA, criei este curso online para quem não consegue aprender só com o material do curso técnico ou faculdade.</p><p>Veja todas as informações sobre o conteúdo do curso nesta página.</p>
                <FormButton buttonName="HeaderCTA" />
            </div>
          );
    }
}

function NewHeaderCTASite({isMobile}) {
    if (isMobile) {
        return (
            <div id="headercta" className="new-header-container">
                {/* <SectionTracker sectionId="HeaderCTA" /> */}
                <h2 className='highlighted-heading'>Está difícil aprender a matéria de circuitos elétricos?</h2>
                <p>Eu, <b>Prof. Nicholas Yukio</b>, engenheiro eletrônico pelo ITA, criei este site para quem não consegue aprender só com o material do curso técnico ou faculdade.</p><p>Temos cursos gratuitos e pagos na nossa área de membros. Veja abaixo.</p>
                <FormButtonSite buttonName="HeaderCTA" />
            </div>
          );
    } else {
        return (
            <div id="headercta" className="new-header-container">
                {/* <SectionTracker sectionId="HeaderCTA" /> */}
                <h2 className='highlighted-heading'>Está difícil aprender a matéria de circuitos elétricos?</h2>
                <p>Eu, <b>Prof. Nicholas Yukio</b>, engenheiro eletrônico pelo ITA, criei este site para quem não consegue aprender só com o material do curso técnico ou faculdade.</p><p>Temos cursos gratuitos e pagos na nossa área de membros. Veja abaixo.</p>
                <FormButtonSite buttonName="HeaderCTA" />
            </div>
          );
    }
}

function CircuitImage() {
    return (
        <figure>
        <img src="/circuito2_fundo_transparente.png" alt="Circuito elétrico RLC" width="800" />
        </figure>
    );
}

function Hero() {
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    return (
    <section class="hero">
    <div className="hero-content">
        <h2>Está difícil aprender a matéria de circuitos elétricos?</h2>
        <p>Aqui no Domínio Elétrico, centenas de alunos de cursos de engenharia elétrica/eletrônica e cursos técnicos relacionados aprendem circuitos elétricos sem depender do sistema da faculdade/escola.</p>
        <p><b>Pegue o seu caderno e junte-se a nós.</b></p>
        {/* <p>Bons estudos,</p>
        <p><i>Prof. Nicholas Yukio - Eng. Eletrônico (ITA)</i></p> */}
        <div className="cta-home-page-wrapper">
            <a href="#form" className="cta-home-page cta-home-page-quero"><ArrowRightCircle size={18} /> Quero ser aluno</a>
        </div>
    </div>
    </section>   
    );
}

function BriefDescription() {
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    const handleButtonClick = () => {
      setIsVideoLoaded(!isVideoLoaded);
    };

    return (
    <section class="hero">
    <div className="hero-content">
        <h2 align="center">O Domínio Elétrico é um curso online de circuitos elétricos. Como assim?</h2>
        {/* <SectionTracker sectionId="BriefDescription" /> */}
        <div>
        {isVideoLoaded ? <Video /> : <CircuitImage />}
        <button className='btn-video' onClick={handleButtonClick}>Ver vídeo sobre o curso</button>
        </div>
        <div className="text">
        <p><strong>"Circuitos Elétricos"</strong> é o nome comum para matérias estudadas em cursos superiores de engenharia, principalmente elétrica e eletrônica. Essa matéria costuma ser ministrada nas disciplinas de Circuitos Elétricos I, II e III e é fundamental para a formação de profissionais dessas engenharias.</p>
        <p><strong>Porém,</strong> é comum que os alunos de faculdades brasileiras, tanto públicas quanto privadas, tenham dificuldades para aprender a matéria apenas com o material e aulas do professor da faculdade. O Domínio Elétrico vem atender melhor essa demanda com um curso de circuitos elétricos com aulas didáticas, exercícios resolvidos, suporte para tira-dúvidas e muito mais.</p>
        <p>Ao longo desta página, você verá todas as informações importantes do curso e poderá decidir se faz sentido para você. Para se inscrever no curso, clique no botão abaixo.</p>
        <FormButton buttonName="BriefDescription" />
        </div>
    </div>
    </section>   
    );
}

function HeroFree() {
    return (
    <section class="hero">
    <div className="hero-content-premium">
        <h2 align="center">Venha dominar os circuitos elétricos!</h2>
        <CustomVideo
        videoId={"d7e6ab88-692d-41b9-878d-bf197bb05706"}
        />
        <div className="text">
        <p>Este site é o lugar ideal para quem deseja estudar circuitos elétricos para dominar o assunto, sem depender das aulas da faculdade de engenharia. Para começar, clique no botão abaixo.</p>
        <a href="#form" className="cta-home-page cta-home-page-quero"><ArrowRightCircle size={18} /> Quero ser aluno</a>
        </div>
    </div>
    </section>   
    );
}

function HeroPremium() {
    return (
    <section class="hero">
    <div className="hero-content-premium">
        <h2 align="center">Venha dominar os circuitos elétricos!</h2>
        <CustomVideo
        videoId={"8efc1250-c0e0-4b9b-b234-ef2285afcc33"}
        />
        <div className="text">
        <p>Este site é o lugar ideal para quem deseja estudar circuitos elétricos para dominar o assunto, sem depender das aulas da faculdade de engenharia. Para começar, clique no botão abaixo.</p>
        <a href="#form" className="cta-home-page cta-home-page-quero"><ArrowRightCircle size={18} /> Quero ser aluno</a>
        </div>
    </div>
    </section>   
    );
}

function BioBlog() {
    return (
    <section className="section">
    <div className="content-container">
    {/* <SectionTracker sectionId="Bio" /> */}
        <figure>
        <img src="/foto_pessoal_pequena-768x765.jpg" alt="Imagem da Seção 1" width="360" className="bio-image" />
        </figure>
        <div className="text">
        <h2>Sobre o Prof. Nicholas Yukio</h2>
        <p>Sou engenheiro eletrônico formado no ITA em 2017. </p>
        <p>Comecei a vida profissional como professor da disciplina de circuitos elétricos no ITA, onde trabalhei de 2018 até março de 2020.</p>
        <p>Em 2019, levei meu ensino de circuitos elétricos para a internet, com minhas aulas públicas no Canal do Elétron.</p>
        <p>No início de 2020, criei meu curso online de circuitos elétricos, o Domínio Elétrico, focado em alunos de engenharia.</p>
        <p>De lá para cá, já são cerca de 500 alunos do curso que aprendem comigo e que podem tirar dúvidas individualmente comigo.</p>
        <p>Muitos são alunos de diversas faculdades, públicas e privadas, mas há também alunos de cursos técnicos e profissionais já formados que querem revisar seus conhecimentos.</p>
        <p>A minha missão aqui é: ensinar da melhor forma possível quem quer estudar sério circuitos elétricos.</p>
        <KnowCourseFromBlogButton buttonName="BlogBioButton" />
        </div>
    </div>
    </section>
    );
}

function CircuitsSec1() {
    return (
    <section className="section">
        {/* <SectionTracker sectionId="ElectronicsContent" /> */}
        <div className="content-container-single-column">
            <h2>O que são circuitos elétricos?</h2>
            <figure>
                <img src="/circuito_eletronico_fundo_transparente.png" alt="Imagem da Seção 1" width="600" />
            </figure>
            <div className="text">
                <h3>O que são circuitos elétricos?</h3>
                <p>Se você conectar uma pilha à uma lâmpada, você tem um circuito elétrico.</p>
            </div>
            <figure>
                <img src="/circuito_eletronico_fundo_transparente.png" alt="Imagem da Seção 1" width="600" />
            </figure>
            <div className="text">
                <h3>Para que servem os circuitos elétricos?</h3>
                <p>Para aprender todas as matérias de engenharia elétrica/eletrônica.</p>
            </div>
            <figure>
                <img src="/circuito_eletronico_fundo_transparente.png" alt="Imagem da Seção 1" width="600" />
            </figure>
            <div className="text">
                <h3>Como aprender circuitos elétricos?</h3>
                <p>Aqui no site Domínio Elétrico.</p>
            </div>
        </div>
    </section>
    );
}

function AllCourseFeatures() {
    return (
        <>
        <CourseFeature
        title="Também tem conteúdo mais específico para o pessoal de eletrônica:"
        text="Quem tem interesse mais específico em eletrônica vai gostar especialmente dos módulos finais (9: Semicondutores, 10: Circuitos Analógicos e 11: Circuitos Digitais).</p><p>No entanto, preciso explicar bem que quero dizer eletrônica no contexto de engenharia e ensino superior. Não faço esta distinção para excluir quem é de fora da engenharia, mas para deixar definido o direcionamento dado no curso, que <span style={{ textDecoration: 'underline'}}>não é aquela ideia popular de eletrônica de montar receitas prontas sem entender nada e consertar aparelhos.</span></p><p><strong>Todos os interessados no assunto de circuitos e que estejam dispostos a estudar são bem vindos."
        image="/circuito_eletronico_fundo_transparente.png"
        bgColor="#e5f7faff"
        />
        <CourseFeature
        title="Serve para quem é iniciante, mas também para quem já se considera avançado."
        text="Se você é um completo iniciante, totalmente perdido em circuitos elétricos, fique tranquilo porque no curso você começará aprendendo dos conceitos mais básicos de tensão e corrente elétrica.</p><p>Você estudará os circuitos elétricos mais básicos, que são aqueles em corrente contínua, para então progredir para o aprendizado de circuitos RL, RC, RLC em resposta transiente e regime permanente, bem como circuitos em corrente alternada (regime permanente senoidal).</p><p>Se você já sabe alguma coisa de circuitos e se considera intermediário ou avançado, poderá partir logo para análise de circuitos usando Laplace e Fourier, bem como para o estudo dos módulos mais finais do curso, mais voltados para projeto de circuitos eletrônicos."
        image={"/do_basico_ao_avancado_fundo_transparente.png"}
        bgColor="#ffffffff"
        />
        <CourseFeature
        title="Dificuldade na matemática para estudar circuitos? Aprenda no Matemática do Elétron."
        text="Se você tem dificuldade em fazer contas mais simples, resolver equações básicas, cálculos com trigonometria ou números complexos, não se preocupe mais. </p><p>Todos esses conceitos de matemática de ensino fundamental e médio são fundamentais para o estudo de circuitos, mas com o Matemática do Elétron você estará amparado. São cerca de 25 horas de aulas gravadas para revisar a matemática básica que você precisa para estudar circuitos."
        image="/logo_mat_de.png"
        bgColor="#e5f7faff"
        />
        <CourseFeature
        title="Não é só teoria, mas prática também. Conheça o Domínio Elétrico Labs."
        text="O Domínio Elétrico Labs é a parte do curso que consiste em aulas de laboratório de eletrônica voltadas especialmente para estudantes no nível de engenharia.</p><p>Ou seja, não são aqueles vídeos quem existem aos montes na internet mostrando a montagem de um circuito com receita pronta que ninguém sabe ao certo como funciona.&nbsp;</p><p>Ao invés disso, o foco nestas aulas de laboratório é mostrar na prática os conceitos explicados nas aulas teóricas, não de fugir delas.</p><p><strong>Para isso, cada aula de laboratório vem com um pré-lab, que é um exercício prévio para você entender o circuito estudado previamente, seguido pelo vídeo do experimento em si, terminando com uma aula teórica sobre o experimento.</strong>"
        image="/de_labs.jpg"
        bgColor="#f5fbfc"
        />
        </>
    );
}

function ElectronicsContent() {
    return (
    <section className="section">
        {/* <SectionTracker sectionId="ElectronicsContent" /> */}
        <div className="content-container">
        <figure>
            <img src="/circuito_eletronico_fundo_transparente.png" alt="Imagem da Seção 1" width="800" />
        </figure>
        <div className="text">
        <h2>Também tem conteúdo mais específico para o pessoal de eletrônica:</h2>
        <p>Quem tem interesse mais específico em eletrônica vai gostar especialmente dos módulos finais (9 – Semicondutores, 10 – Circuitos Analógicos e 11 – Circuitos Digitais).</p><p>No entanto, preciso explicar bem que quero dizer eletrônica no contexto de engenharia e ensino superior. Não faço esta distinção para excluir quem é de fora da engenharia, mas para deixar definido o direcionamento dado no curso, que <span style={{ textDecoration: 'underline'}}>não é aquela ideia popular de eletrônica de montar receitas prontas sem entender nada e consertar aparelhos.</span></p><p><strong>Todos os interessados no assunto de circuitos e que estejam dispostos a estudar são bem vindos.</strong></p>
        <FormButton buttonName="ElectronicsContent" />
        </div>
        </div>
    </section>
    );
}

function FromBasicsToAdvanced() {
    return (
    <section className="section">
        {/* <SectionTracker sectionId="FromBasicsToAdvanced" /> */}
        <div className="content-container">
        <figure>
        <img src="/do_basico_ao_avancado_fundo_transparente.png" alt="Imagem da Seção 1" width="800" />
        </figure>
        <div className="text">
        <h2>Serve para quem é iniciante, mas também para quem já se considera avançado.</h2>
        <p>Se você é um completo iniciante, totalmente perdido em circuitos elétricos, fique tranquilo porque no curso você começará aprendendo dos conceitos mais básicos de tensão e corrente elétrica.</p><p>Você estudará os circuitos elétricos mais básicos, que são aqueles em corrente contínua, para então progredir para o aprendizado de circuitos RL, RC, RLC em resposta transiente e regime permanente, bem como circuitos em corrente alternada (regime permanente senoidal).</p><p>Se você já sabe alguma coisa de circuitos e se considera intermediário ou avançado, poderá partir logo para análise de circuitos usando Laplace e Fourier, bem como para o estudo dos módulos mais finais do curso, mais voltados para projeto de circuitos eletrônicos.&nbsp;</p>
        <FormButton buttonName="FromBasicsToAdvanced" />
        </div>
        </div>
    </section>
    );
}

function MatematicaDoEletron() {
    return (
    <section className="section">
        {/* <SectionTracker sectionId="MatematicaDoEletron" /> */}
        <div className="content-container">
        <figure>
        <img src="/logo_mat_de.png" alt="Logo do curso MdE" width="800" />
        </figure>
        <div className="text">
        <h2>Dificuldade na matemática para estudar circuitos? Aprenda no Matemática do Elétron.</h2>
        <p>Se você tem dificuldade em fazer contas mais simples, resolver equações básicas, cálculos com trigonometria ou números complexos, não se preocupe mais. </p><p>Todos esses conceitos de matemática de ensino fundamental e médio são fundamentais para o estudo de circuitos, mas com o Matemática do Elétron você estará amparado. São cerca de 25 horas de aulas gravadas para revisar a matemática básica que você precisa para estudar circuitos.&nbsp;</p>
        <FormButton buttonName="MatematicaDoEletron" />
        </div>
        </div>
    </section>
    );
}

function TheoryAndPractice() {
    return (
    <section className="section">
        {/* <SectionTracker sectionId="TheoryAndPractice" /> */}
        <div className="content-container">
        <figure>
        <img src="/de_labs.jpg" alt="Imagem da Seção 1" width="800" />
        </figure>
        <div className="text">
        <h2>Não é só teoria, mas prática também. Conheça o Domínio Elétrico Labs.</h2>
        <p>O Domínio Elétrico Labs é a parte do curso que consiste em aulas de laboratório de eletrônica voltadas especialmente para estudantes no nível de engenharia.</p><p>Ou seja, não são aqueles vídeos quem existem aos montes na internet mostrando a montagem de um circuito com receita pronta que ninguém sabe ao certo como funciona.&nbsp;</p><p>Ao invés disso, o foco nestas aulas de laboratório é mostrar na prática os conceitos explicados nas aulas teóricas, não de fugir delas.</p><p><strong>Para isso, cada aula de laboratório vem com um pré-lab, que é um exercício prévio para você entender o circuito estudado previamente, seguido pelo vídeo do experimento em si, terminando com uma aula teórica sobre o experimento.</strong></p>
        <FormButton buttonName="TheoryAndPractice" />
        </div>
        </div>
    </section>
    );
}

const EditCreditCardPage = () => {
    //const [showOffer, setGlobalVariable] = useState(false);

    //const handleVariableChange = (newValue) => {
        // Update the globalVariable when needed
      //  setGlobalVariable(newValue);
    //};

    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
        <>
        <HeaderInternal isMobile={isMobile}/>
        <EditCreditCard isMobile={isMobile}/>
        <RodapeInternal />
        </>
	);
};